import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import fromEntries from 'fromentries';
import { get } from 'lodash';
import { useUserById } from 'ui-model';

import { patientFormTemplatesResource } from '@lib/resources';

export function useHeaderViewModel(isGuestLink = false) {
  const dispatch = useDispatch();
  // TEMP - IE polyfill until july 2022
  const searchParams = fromEntries(new URLSearchParams(window.location.search));
  const isOnLoginPage = window.location.pathname === '/login';
  const patientFormTemplateId = get(searchParams, 'patientFormTemplate', '');
  const currentPatientFormTemplate = useSelector(patientFormTemplatesResource.makeSelectEntity(patientFormTemplateId));
  const [patientFormTemplateRootAccountId, setPatientFormTemplateRootAccountId] = useState(
    get(currentPatientFormTemplate, 'user', ''),
  );

  const { data, ...results } = useUserById(
    { id: patientFormTemplateRootAccountId },
    {
      enabled: !!patientFormTemplateRootAccountId && !isOnLoginPage,
      staleTime: 1000 * 5,
    },
  );

  useEffect(() => {
    if (patientFormTemplateId && !patientFormTemplateRootAccountId && !isGuestLink && !isOnLoginPage) {
      dispatch(
        patientFormTemplatesResource.fetch({
          id: patientFormTemplateId,
          params: { includeDeleted: true },
          meta: {
            callbackSuccess: (response) => {
              setPatientFormTemplateRootAccountId(get(response, 'data.user', ''));
            },
          },
        }),
      );
    }
  }, [dispatch, isGuestLink, patientFormTemplateId, patientFormTemplateRootAccountId, isOnLoginPage]);

  return { rootAccount: data, ...results };
}
